import React from 'react'
import {useForm} from 'react-hook-form'
import {useNiftyFiftyUpdate, NiftyFifty} from 'Event/template/NiftyFifty'
import ComponentConfig, {
  ComponentConfigProps,
  SaveButton,
  Footer,
} from 'organization/Event/DashboardConfig/ComponentConfigPanel'
import Settings from 'Event/template/NiftyFifty/Dashboard/Home/WelcomeTextConfig/Settings'
import Styling from 'Event/template/NiftyFifty/Dashboard/Home/WelcomeTextConfig/Styling'
import SettingsPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/SettingsPanel'
import StylingPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/StylingPanel'
import {useAutoUpdate} from 'organization/Event/TemplateEditor'
import {useAddTranslation} from 'Event/LanguageProvider'

export default function WelcomeTextConfig(props: ComponentConfigProps) {
  const {showing, onClose} = props
  const {control, register, watch, handleSubmit, formState} = useForm()
  const update = useNiftyFiftyUpdate()
  const addTranslation = useAddTranslation()

  const save = (
    data: Pick<
      NiftyFifty,
      | 'welcomeText'
      | 'homeMenuTitle'
      | 'welcomeTextFont'
      | 'welcomeTextColor'
      | 'welcomeTextFontSize'
    >,
  ) => {
    update({
      localization: addTranslation({
        welcome_text: data.welcomeText,
        home_menu_title: data.homeMenuTitle,
      }),
      ...data,
      welcomeText: '{{welcome_text}}',
      homeMenuTitle: '{{home_menu_title}}',
    })
    onClose()
  }

  useAutoUpdate({values: watch(), when: showing})

  return (
    <ComponentConfig
      showing={showing}
      onClose={onClose}
      title="Welcome Text"
      onSubmit={handleSubmit(save)}
      hasChanges={formState.isDirty}
    >
      <SettingsPanel>
        <Settings register={register} />
      </SettingsPanel>
      <StylingPanel>
        <Styling control={control} />
      </StylingPanel>
      <Footer>
        <SaveButton type="submit" aria-label="save welcome text" />
      </Footer>
    </ComponentConfig>
  )
}
